import { all, takeEvery, call, put } from 'redux-saga/effects';
import propertySubscribeActions from './actions';
import SuperFetch from '../../helpers/superFetch';
import { apiUrls } from '../../settings';
import { getaddressConfig } from '../../settings';
import isEmpty from 'lodash/isEmpty';

const doMakeStripeSubscribePayment = async payload => {

  const postData = {
    data: {
      cardname: payload.payload.cardName || '',
      propertyHash: payload.payload.propertyHash || '',
      stripeToken: payload.payload.token && payload.payload.token.id || '',
      billingAddress: {
        firstName: payload.payload.firstName || '',
        lastName: payload.payload.lastName || '',
        line1: payload.payload.address1 || '',
        city: payload.payload.postTown || '',
        state: payload.payload.county || '',
        zip: payload.payload.postCode || '',
        country : "UK"
      }
    }
  };
  return await SuperFetch.post(`${apiUrls.landlordMakeStripeSubscriptionPayment}`, postData)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
};

export function* makeStripeSubscriptionPayment(payload) {
  const payment = yield call(doMakeStripeSubscribePayment, payload);
  yield [
    put(propertySubscribeActions.doMakeStripeSubscribePaymentSucceeded(payment))
  ];
}

const doListPropertyImages = async payload => {
  return await SuperFetch.post(`${apiUrls.getPropertyImages}?propertyHash=${payload.data.propertyHash}`)
    .then(res => res)
    .catch(error => ({
      error: JSON.stringify(error)
    }));
};

export function* getPropertyImages(payload) {
  const propertyImages = yield call(doListPropertyImages, payload.payload);
  yield [
    put(propertySubscribeActions.doListPropertyImagesSucceeded(propertyImages))
  ];
}


export default function* rootSaga() {
  yield all([
    takeEvery(propertySubscribeActions.DO_MAKE_STRIPE_SUBSCRIBE_PAYMENT, makeStripeSubscriptionPayment),
    takeEvery(propertySubscribeActions.DO_LIST_PROPERTY_IMAGES, getPropertyImages),
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/propertiesSubscribe/sagas.js